import React from 'react';
import { Checkbox } from 'antd';
import classNames from 'classnames';

import { Button, Tooltip } from '../../../components';
import { trashIcon, Condition, getConditionTestId } from '../rule/rule-utils';
import IndexedLabel from '../../../components/indexed-label/indexed-label';
import AttributePath from '../rule/components/attribute-path';

import './../conditions.scss';

export interface BooleanTranslations {
	removeTooltipText?: string;
	trueOption: string;
	falseOption: string;
}

export interface BooleanConditionProps {
	disabled?: boolean;
	index?: number;
	maxAttributePathItems?: number;
	condition: Condition;
	translations: BooleanTranslations;
	onChange(condition: Condition, value: boolean): void;
	onRemove(condition: Condition): void;
	withIndexedLabel?: boolean;
}

const BooleanCondition: React.FC<BooleanConditionProps> = ({
	condition,
	index,
	onChange,
	onRemove,
	translations,
	withIndexedLabel = true,
	disabled = false,
	maxAttributePathItems
}: BooleanConditionProps) => {
	const { name, value } = condition;
	const handleChange = value => {
		onChange(condition, value);
	};

	const options = [
		{ label: translations.falseOption, value: false },
		{ label: translations.trueOption, value: true }
	];
	return (
		<div
			className={classNames('condition-container', { 'disabled-condition': disabled })}
			data-test-id={getConditionTestId(name)}
		>
			{index && withIndexedLabel && <IndexedLabel index={index} />}
			<div id={!withIndexedLabel ? 'short-name' : undefined} className="name">
				<AttributePath path={name} maxPathItems={maxAttributePathItems} />
			</div>
			<Checkbox.Group
				disabled={disabled}
				options={options}
				value={value.length ? (value as boolean[]) : []}
				onChange={handleChange}
			/>
			<Tooltip placement="top" title={translations.removeTooltipText}>
				<Button shape="circle" className="remove-button" icon={trashIcon} onClick={() => onRemove(condition)} />
			</Tooltip>
		</div>
	);
};

export default BooleanCondition;
